export enum BANDEAU_URL {
  HOME = 'home',
  EXP_AUTO = 'expedition-auto',
  EXP_MANUELLE = 'expedition-manuel',
  SORTIE_VOL = 'association-sortie-vol',
  RECHERCHE_EXP = 'recherche-expeditions',
  RECHERCHE_CONTENANTS = 'recherche-contenants',
}

export enum BANNER {
  BANNER_EXP_AUTO = 'Expédition Flux TCA',
  BANNER_EXP_MANUELLE = 'Expédition Manuelle',
  BANNER_SORTIE_VOL = 'Association Sortie - Vol',
  BANNER_DEFAULT_EXP = 'Expédition',
  RECHERCHE_CONTENANTS = 'Recherche de contenants',
}
